import {
  FrontendSettingsTab,
  SettingsTabDef,
} from '../interfaces/Settings/SettingsTab';
import { GeneralFrontendSettings } from '../pages/FrontendSettings/TabContent/GeneralFrontendSettings';
import { SocialMediaSettings } from '../pages/FrontendSettings/TabContent/SocialMediaSettings';
import { LogoSettings } from '../pages/FrontendSettings/TabContent/LogoSettings';
import { MenuSettings } from '../pages/FrontendSettings/TabContent/MenuSettings';
import { LocalizationSettings } from '../pages/FrontendSettings/TabContent/LocalizationSettings';

export const availableFrontendSettingsTabs: SettingsTabDef<FrontendSettingsTab>[] =
  [
    {
      kind: FrontendSettingsTab.GENERAL,
      name: 'Genel',
      path: 'general',
      element: <GeneralFrontendSettings />,
    },
    {
      kind: FrontendSettingsTab.MENU,
      name: 'Menü',
      path: 'menu',
      element: <MenuSettings />,
    },
    {
      kind: FrontendSettingsTab.LOGO,
      name: 'Logo',
      path: 'logo',
      element: <LogoSettings />,
    },
    {
      kind: FrontendSettingsTab.SOCIAL,
      name: 'Sosyal Medya',
      path: 'social',
      element: <SocialMediaSettings />,
    },
    {
      kind: FrontendSettingsTab.LOCALIZATION,
      name: 'Lokalizasyon',
      path: 'localization',
      element: <LocalizationSettings />,
    },
  ];
